import React, { Component } from 'react';
import Error from 'models/Error';
// import ErrorComp from 'components/Error';
import {inject, observer} from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface IErrorCatcherProps extends RouteComponentProps {
  error?: Error;
}

@inject('error')
@observer
class ErrorBoundary extends Component<IErrorCatcherProps,{}> {
  
  componentDidCatch(error:any, info:any) {
    this.props.history.replace('/Error');
  }

  render() {
    return (
      <>
      {this.props.children}
      </>
    );
  }
}

export default withRouter(ErrorBoundary);